import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "../../api";
import { Spinner } from "../../components/Logo";
import { PageHeader, StatusChip } from "../../components/ui";
import { ShieldX, RefreshCw, Award } from "lucide-react";

export default function AdminCertificates() {
  const [rows, setRows] = useState(null);
  const load = () => api.get("/admin/certificates").then((r) => setRows(r.data.certificates)).catch(() => {});
  useEffect(() => { load(); }, []);

  const revoke = async (id) => { try { await api.post(`/admin/certificates/${id}/revoke`); toast.success("Revoked"); load(); } catch (e) { toast.error(apiError(e)); } };
  const reissue = async (id) => { try { await api.post(`/admin/certificates/${id}/reissue`); toast.success("Reissued"); load(); } catch (e) { toast.error(apiError(e)); } };

  return (
    <div data-testid="admin-certificates">
      <PageHeader overline="Credentials" title="Certificate management" desc="Issue automatically on path completion. Revoke or reissue as needed — history is preserved." />
      {!rows ? <Spinner /> : (
        <div className="card overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead><tr className="text-slate-400 uppercase text-xs tracking-wider border-b border-white/10">
              <th className="py-3 px-4">Holder</th><th className="px-4">Certificate</th><th className="px-4">Verification ID</th><th className="px-4">Status</th><th className="px-4">Issued</th><th className="px-4 text-right">Actions</th>
            </tr></thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} className="border-b border-white/5 hover:bg-white/5" data-testid={`admin-cert-${c.id}`}>
                  <td className="py-3 px-4"><div className="font-medium">{c.full_name}</div><div className="text-slate-500 text-xs">{c.email}</div></td>
                  <td className="px-4 text-slate-300">{c.title}</td>
                  <td className="px-4 font-mono text-xs text-slate-400">{c.verification_id}</td>
                  <td className="px-4"><StatusChip status={c.status} /></td>
                  <td className="px-4 text-slate-400 text-xs">{new Date(c.issued_at).toLocaleDateString()}</td>
                  <td className="px-4"><div className="flex items-center justify-end gap-1">
                    {c.status === "valid" ? (
                      <button className="btn-ghost !px-2 text-red-400" title="Revoke" onClick={() => revoke(c.id)} data-testid={`revoke-cert-${c.id}`}><ShieldX size={16} /></button>
                    ) : (
                      <button className="btn-ghost !px-2 text-emerald-400" title="Reissue" onClick={() => reissue(c.id)} data-testid={`reissue-cert-${c.id}`}><RefreshCw size={16} /></button>
                    )}
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
          {rows.length === 0 && <div className="p-10 text-center text-slate-500 flex flex-col items-center gap-3"><Award size={28} /> No certificates issued yet.</div>}
        </div>
      )}
    </div>
  );
}
